<template>
  <div class="content">
    <h3>系统模块设置</h3>
    <el-button
      type="primary"
      style="margin: 0 0 10px 0;"
      icon="el-icon-plus"
      @click="AddModule"
      >添加</el-button
    >
    <el-table
      :data="tableData" border row-key="ModuleId"
      :header-cell-style="{ 'text-align': 'center' }"
      :tree-props="{ children: 'Child', hasChildren: 'hasChildren' }"
      >>
      <el-table-column prop="ModuleName" align="left" label="模块名称"></el-table-column>
      <el-table-column prop="ModuleCode" align="center" label="模块编号"></el-table-column>
      <el-table-column prop="WebPageUrl" align="center" label="模块路径"></el-table-column>
      <el-table-column align="center" label="模块状态">
        <template slot-scope="scope">
          {{ scope.row.Status ? "启用" : "禁止" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标">
        <template slot-scope="scope">
          <i :class="scope.row.icon" style="font-size:22px"></i>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="SeqNo"
        label="模块序号"
      ></el-table-column>
      <el-table-column align="center" prop="UserName" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="UpdateModule(scope)" size="small"
            >编辑</el-button
          >
          <el-button type="text" @click="DeleteModule(scope)" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="dialogtype == 1 ? '添加模块' : '编辑模块'"
      @close="close"
      :visible.sync="dialogVisible"
      width="740px"
    >
      <el-form
        ref="form"
        inline
        style="width:auto"
        :model="form"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="模块编号" prop="ModuleCode">
          <el-input disabled v-model="form.ModuleCode"></el-input>
        </el-form-item>
        <el-form-item label="模块名称" prop="ModuleName">
          <el-input v-model="form.ModuleName"></el-input>
        </el-form-item>
        <el-form-item label="模块路径" prop="WebPageUrl">
          <el-input v-model.trim="form.WebPageUrl"></el-input>
        </el-form-item>
        
        <el-form-item label="模块图标" prop="icon">
          <el-select v-model="form.icon" clearable placeholder="请选择">
            <el-option
              v-for="item in icons"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <i :class="item.value" style="font-size:22px"></i>
              <span>{{ item.value }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属父模块">
          <el-cascader
          ref="cascader"
              v-model="cader" clearable
              :options="parentModulesData"
              :props="cascaderprops"
              @change="handleChange">
            </el-cascader>
        </el-form-item>
        
        <el-form-item label="模块级别" prop="ModuleDataTypeId">
          <el-input disabled v-model="form.ModuleDataTypeId"></el-input>
        </el-form-item>

        <el-form-item label="模块序号" prop="SeqNo">
          <el-input v-model="form.SeqNo"></el-input>
        </el-form-item>
        
        <el-form-item
          label="模块状态"
          prop="Status"
          style="line-height: 40px;text-align: center;"
        >
          <el-radio v-model="form.Status" :label="1">启用</el-radio>
          <el-radio v-model="form.Status" :label="0">禁用</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="restForm" type="warning">重 置</el-button>
        <el-button type="primary" @click="SetMoudle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import modulesicon from "../utils/name.json";
export default {
  data() {
    return {
      cascaderprops: { 
        checkStrictly: true,
        value:'ModuleId',
        label:'ModuleName',
        children:'Child'
      },
      form: {
        ModuleId: 0,
        ModuleCode: "",
        ModuleName: "",
        WebPageUrl: "",
        ParentModuleId: 0,
        icon: "",
        SeqNo: "0",
        Status: 1,
        ModuleDataTypeId:1
      },
      rules: {
        ModuleName: [
          { required: true, message: "请输入模块名称", trigger: "blur" }
        ]
      },
      tableData: [],
      dialogVisible: false,
      dialogtype: 0,
      icons: [],
      cader:[],
      parentModulesData:[]
    };
  },
  mounted: function() {
    this.GetModules();
    for (let i in modulesicon) {
      this.icons.push({
        lable: modulesicon[i]._prevClass,
        value: modulesicon[i]._prevClass
      });
    }
  },
  methods: {
    handleChange(value) {
        this.form.ParentModuleId=value[value.length-1]
        this.form.ModuleDataTypeId=value.length+1
    },
    close() {
      this.cader=[]
      this.$refs["form"].resetFields();
    },
    restForm() {
      this.$nextTick(() => {
        this.cader=[]
        this.$refs["form"].resetFields();
      });
    },
    GetModules() {
      this.$axios({
        method: "post",
        url: "/FW/RoleAssign.ashx",
        params: {
          action: "getModules"
        }
      }).then(res => {
        if (res.Code == 0) {
          this.tableData = res.Data;
          let arr = JSON.parse(JSON.stringify(res.Data))
          arr.forEach((lev1)=>{
            lev1.Child.forEach((lev2)=>{
              lev2.Child=undefined
            })
          })
          this.parentModulesData=arr
        } else {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "warning"
          });
        }
      });
    },

    AddModule() {
      this.dialogVisible = true;
      this.dialogtype = 1;
      this.$axios({
              method: "post",
              url: "/FW/SetMoldules.ashx",
              params: {
                action: "GetModuleCode",
                form: ''
              }
            }).then(res => {
              if (res.Code == 0) {
                this.form.ModuleCode=res.Data
              } else {
                this.$message({
                  showClose: true,
                  message: res.Msg,
                  type: "warning"
                });
              }
            })
      
    },
    UpdateModule(scope) {
      this.dialogVisible = true;
      this.dialogtype = 2;
      this.$nextTick(() => {
        this.form.ModuleId = scope.row.ModuleId;
				this.form.ModuleCode = scope.row.ModuleCode;
        this.form.ModuleName = scope.row.ModuleName;
        this.form.WebPageUrl = scope.row.WebPageUrl;
        this.form.ParentModuleId = scope.row.ParentModuleId;
        this.form.icon = scope.row.icon;
        this.form.SeqNo = scope.row.SeqNo;
        this.form.Status = scope.row.Status;
        this.form.ModuleDataTypeId = scope.row.ModuleDataTypeId;
      }) 
      let arr=[];
      arr.length=scope.row.ModuleDataTypeId-1;
      var parentModuleId=scope.row.ParentModuleId;
      if (arr.length==1){
        arr[0]=parentModuleId
      }else if (arr.length==2){
        this.tableData.forEach(lev1 => {
          if(lev1.Child.length!=0){
            lev1.Child.forEach(lev2 => {
              if (lev2.ModuleId==parentModuleId){
                arr[0]=lev1.ModuleId
                arr[1]=lev2.ModuleId
              }
            })
          }
        })
      }
      console.log(arr)
      this.cader = arr
      
    },
    SetMoudle() {
      this.$refs["form"].validate(isValidate => {
        if (isValidate) {
          if (this.dialogtype == 1) {
            this.$axios({
              method: "post",
              url: "/FW/SetMoldules.ashx",
              params: {
                action: "AddModules",
                form: this.form
              }
            }).then(res => {
              if (res.Code == 0) {
                this.$message({
                  showClose: true,
                  message: res.Msg,
                  type: "success"
                });
                this.GetModules();
              } else {
                this.$message({
                  showClose: true,
                  message: res.Msg,
                  type: "warning"
                });
              }
            });
          } else if (this.dialogtype == 2) {
            this.$axios({
              method: "post",
              url: "/FW/SetMoldules.ashx",
              params: {
                action: "UpdateModule",
                form: this.form
              }
            }).then(res => {
              if (res.Code == 0) {
                this.$message({
                  showClose: true,
                  message: res.Msg,
                  type: "success"
                });
                this.GetModules();
              } else {
                this.$message({
                  showClose: true,
                  message: res.Msg,
                  type: "warning"
                });
              }
            });
          }
        } else {
          return;
        }
      });
    },
    DeleteModule(scope) {
      this.$axios({
        method: "post",
        url: "/FW/SetMoldules.ashx",
        params: {
          action: "DeleteModule",
          form: scope.row
        }
      }).then(res => {
        if (res.Code == 0) {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "success"
          });
          this.GetModules();
        } else {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "warning"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.title {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/moduleSettings.vue